import * as React from "react";
import FadingElement from "../animation/fading-element/fading-element";
import { GoogleAnalyticsEventType } from "../../models/google-analytics";
import * as googleAnalyticsService from "../../services/google-analytics-service";
import styled from "styled-components";

/** FeaturesVerticalBlockElement */
interface FeaturesVerticalBlockElementProps extends FeatureVerticalElementData {
  isActive: boolean
}

const FeaturesVerticalBlockElement = (props: FeaturesVerticalBlockElementProps) => {
  const {isActive,featureName,featureDescription,featureImage} = props;
  return (
    <FadingElement in={isActive}>
      <FeaturesVerticalBlockElementWrapper className={isActive ? "tab-pane fade in active" : "tab-pane fade in"}>
        <StyledH2>{featureName}</StyledH2>
        <img className="alignright" src={featureImage}/>
        {featureDescription.map((description: string, index: number) =>
          <p key={index}>{description}</p>
        )}
      </FeaturesVerticalBlockElementWrapper>
    </FadingElement>
  )
};

/** STYLES */

const FeaturesVerticalBlockElementWrapper = styled.div`
  height: 300px;
  color: #808080 !important;
  padding: 15px;
  @media (max-width: 899px) {
    height: auto;
    img {
      display: none !important;
    }
  }
`;

const StyledH2 = styled.h2`
  line-height: 22px;
`;


/** FeaturesVerticalBlock */
interface FeaturesVerticalBlockProps {
  /** FICZERY DO ZAPREZENTOWANIA */
  features: FeatureVerticalElementData[]

  /** GOOGLE EVENT TO TRIGGER ON SECTION VIEW */
  componentViewEventType?: GoogleAnalyticsEventType

  /** GOOGLE EVENT TYPE TO TRIGER ON BUTTON CLICK */
  buttonClickEventType?: GoogleAnalyticsEventType
}

interface FeaturesVerticalBlockState {
  activeTabIndex: number
}

class FeaturesVerticalBlock extends React.Component<FeaturesVerticalBlockProps,FeaturesVerticalBlockState> {

  constructor(props: FeaturesVerticalBlockProps) {
    super(props);
    this.state = {
      activeTabIndex: 0
    };
    this.onComponentView = this.onComponentView.bind(this);
    this.onTabSelect = this.onTabSelect.bind(this);
  }

  onComponentView() {
    if (this.props.componentViewEventType) {
      googleAnalyticsService.trackEvent(this.props.componentViewEventType);
    }
  }

  onTabSelect(index: number) {
    // ZMIANA AKTYWNEGO TABA
    this.setState({activeTabIndex: index});

    // GOOGLE EVENT
    if (this.props.buttonClickEventType) {
      googleAnalyticsService.trackEvent(this.props.buttonClickEventType);
    }
  }

  render() {
    const {features} = this.props;
    const {activeTabIndex} = this.state;
    return (
      <div className="materialize-theme-styles" onMouseEnter={this.onComponentView}>
        <FeaturesVerticalBlockWrapper>
          <div className="container">
            <div className="vertical-tab">
              <div className="row">

                <div className="col-sm-3">
                  <ul className="nav nav-tabs nav-stacked" role="tablist">
                    {features.map((feature: FeatureVerticalElementData, index: number) =>
                      <li key={index} role="presentation" className={activeTabIndex == index ? "active" : ""} onClick={() => this.onTabSelect(index)}>
                        <a className="waves-effect waves-light">{feature.featureName}</a>
                      </li>
                    )}
                  </ul>
                </div>

                <div className="col-sm-9">
                  <div className="panel-body">
                    <div className="tab-content">
                      {features.map((feature: FeatureVerticalElementData, index: number) =>
                        <FeaturesVerticalBlockElement
                          key={index}
                          isActive={activeTabIndex == index}
                          featureName={feature.featureName}
                          featureDescription={feature.featureDescription}
                          featureImage={feature.featureImage}
                        />
                      )}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </FeaturesVerticalBlockWrapper>
      </div>
    )
  }

}

/** STYLES */

const FeaturesVerticalBlockWrapper = styled.section`
  padding-top: 0px !important;
  padding-bottom: 50px;
  div.container {
    width: 90%;
    @media (max-width: 800px) {
      width: 100%;
      margin-left: -10px;
    }
  }
  div.row {
    display: flex;
    div.col-sm-9 {
      box-shadow: rgba(0,0,0,0.25) 0px 1px 16px, rgba(0,0,0,0.25) 0px 1px 14px;
      background: #fff !important;
    }
  }
`;

const FeaturesVerticalCardWrapper = styled.div``;

export default FeaturesVerticalBlock


// WEBPACK FOOTER //
// ./src/layouts/features-vertical-block/features-vertical-block.tsx